
import common from '@/tools/common'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Drawer from 'vux/src/components/drawer/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {
Radio,
Group,
Cell,
Badge,
Drawer,
ButtonTab,
ButtonTabItem,
ViewBox,
XHeader,
Tabbar,
TabbarItem,
Loading,
Actionsheet
},
methods: {
async SetTitle (value) {
this.title = value
}
},
created () {
if (this.UserType === common.UserType.Type9) {
this.title = '研究报告查询'
}
if (this.UserType === common.UserType.Type10) {
this.title = '法规文本查询'
}
},
mounted () {
common.setcustomsSession('dtoken',common.getUrlParam_Title('downtoken') == null ? '' : common.getUrlParam_Title('downtoken'))
common.setcustomsSession('utoken',common.getUrlParam_Title('usertoken') == null ? '' : common.getUrlParam_Title('usertoken'))
common.setcustomsSession('downtype',common.getUrlParam_Title('downtype') == null ? '' : common.getUrlParam_Title('downtype'))
var power = common.getUrlParam('power')
if (this.$route.query.MyId) {
window.localStorage.setItem('MyId', this.$route.query.MyId)
}
if (power == null) {
} else {
common.setPower(power)
}
power = common.getPower()
this.powers = 1
let existtitle = common.getUrlParam('existtitle')
if (power == null) {
this.title = '统计商品目录'
power = ''
} else {
}
if (this.UserType === common.UserType.Type1) {
this.title = '报关手册'
this.mshow = existtitle
if (power.indexOf('SPXX0001') < 0) {
this.$router.replace({name: 'NoPower'})
this.powers = 0
}
return
}
if (this.UserType === common.UserType.Type2) {
this.title = '税则/税则对照/申报目录'
this.mshow = existtitle
console.log(this.mshow)
if (power.indexOf('SPXX0007') < 0) {
this.$router.replace({name: 'NoPower'})
this.powers = 0
}
return
}
if (this.UserType === common.UserType.Type3) {
this.title = '统计商品目录'
}
if (this.UserType === common.UserType.Type7) {
this.title = '关务咨询'
}
if (this.UserType === common.UserType.Type4) {
this.title = '海关法规'
if (power.indexOf('HGFG0001') < 0) {
this.$router.replace({name: 'NoPower'})
this.powers = 0
}
return
}
if (this.UserType === common.UserType.Type8) {
this.title = '食品法规'
}
if (this.UserType === common.UserType.Type9) {
this.title = '研究报告查询'
}
if (this.UserType === common.UserType.Type10) {
this.title = '法规文本查询'
}
if (this.UserType === common.UserType.Type5) {
this.title = '海关统计年鉴'
}
if (this.UserType === common.UserType.Type11) {
this.title = '内控节点随手查'
}
},
beforeDestroy () {
this.box && this.box.removeEventListener('scroll', this.handler, false)
},
watch: {
},
computed: {
leftOptions () {
return {
showBack: this.$route.path !== '/'
}
},
NavData: function () {
let navData = this.GridData
.filter(item => (!item.UserType) || item.UserType.includes(this.UserType))
return navData
},
UserType () {
if (this.$route.query.UserType) {
window.localStorage.setItem('UserType', this.$route.query.UserType)
}
return window.localStorage.getItem('UserType')
},
MyId () {
if (this.$route.query.MyId) {

window.localStorage.setItem('MyId', this.$route.query.MyId)
}

return window.localStorage.getItem('MyId')
}
},
data () {
return {
powers: 0,
lists: [
common.getUrlParam_Title('m_title') == null ? '' : common.getUrlParam_Title('m_title')
],
title: '',
utoken: '',
downtype: common.getUrlParam_Title('downtype') == null ? '' : common.getUrlParam_Title('downtype'),
mshow: 0,
GridData: [
{text: '监管证件', link: '/Licensed', UserType: [common.UserType.Type1], class: 'icon fa fa-id-card', default: true},
{text: '商品信息', link: '/GoodsInfo', UserType: [common.UserType.Type1], class: 'icon fa fa-cubes'},
{text: '通关参数', link: '/PassEntryParam', UserType: [common.UserType.Type1], class: 'icon fa fa-truck'},
{text: '我的定制', link: '/MyCustoms', UserType: [common.UserType.Type1], class: 'icon fa fa-user-o'},

{text: '税费证件', link: '/TaxLicensed', UserType: [common.UserType.Type2], class: 'icon fa fa-id-card', default: true},

{text: '申报要素', link: '/DeclareKeyElement', UserType: [common.UserType.Type2], class: 'icon fa fa-list'},
{text: '我的定制', link: '/MyCustoms', UserType: [common.UserType.Type2], class: 'icon fa fa-user-o'},

{text: '商品目录', link: '/StatsDir', UserType: [common.UserType.Type3], class: 'icon fa fa-cubes', default: true},
{text: '主要商品', link: '/MainGoods', UserType: [common.UserType.Type3], class: 'icon fa fa-cube'},
{text: '商品量值', link: '/GoodsSizeQuery', UserType: [common.UserType.Type3], class: 'icon fa fa-calculator'},

{text: '用户中心', link: '/MyCustoms', UserType: [common.UserType.Type3], class: 'icon fa fa-user-o'}
]
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue